import React from 'react';
import { Route } from 'react-router-dom';
import InfoPage from './../src/components/Info/InfoPage';

export default [
    <Route exact path="/info" component={InfoPage} />,
]